<script setup>
const { t } = useI18n({ useScope: "local" });

const props = defineProps({
  isValid: {
    type: Boolean,
    default: true,
  },
  loaded: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div
    class="relative py-1 cursor-pointer h-[48px] bg-[#F9F9F9] border flex items-center rounded-xl md:rounded-3xl leading-none px-4"
    :class="[isValid ? 'border-[#e3e3e3]' : 'border-red']"
  >
    <a-icon-clip
      class="w-5 h-5 absolute left-4 top-3 cursor-pointer"
    ></a-icon-clip>

    <div class="pl-9 text-base xs:text-sm my-auto sm:text-base text-[#6F6F6F] font-sans">
      <slot />
    </div>

    <div v-if="loaded">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23.652"
        height="17.636"
        viewBox="0 0 23.652 17.636"
      >
        <g id="check" transform="translate(0.5 0.5)">
          <path
            id="Контур_433"
            data-name="Контур 433"
            d="M22.321,68.329a1.133,1.133,0,0,0-1.6,0L7.149,81.9,1.933,76.683a1.133,1.133,0,0,0-1.6,1.6L6.348,84.3a1.133,1.133,0,0,0,1.6,0L22.321,69.931A1.133,1.133,0,0,0,22.321,68.329Z"
            transform="translate(0 -67.997)"
            fill="#3b9c32"
          />
          <path
            id="Контур_433_-_Рамка"
            data-name="Контур 433 - Рамка"
            d="M21.52,67.5a1.633,1.633,0,0,1,1.154,2.787L8.3,84.655a1.633,1.633,0,0,1-2.309,0L-.022,78.638a1.633,1.633,0,0,1,1.154-2.787,1.622,1.622,0,0,1,1.154.478l4.862,4.862L20.365,67.976A1.622,1.622,0,0,1,21.52,67.5ZM7.149,84.133a.629.629,0,0,0,.447-.185L21.967,69.578a.633.633,0,1,0-.895-.895L7.149,82.606l-5.57-5.57a.633.633,0,1,0-.895.895L6.7,83.948A.628.628,0,0,0,7.149,84.133Z"
            transform="translate(0 -67.997)"
            fill="#3b9c32"
          />
        </g>
      </svg>
    </div>
  </div>
</template>
